import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import frame1 from "../../assets/frame4.png";
import frame2 from "../../assets/frame5.png";
import frame3 from "../../assets/frame6.png";
import upcomingEventJuly from "../../assets/upcoming_event_july.png";

const imageFrames = [
  { type: "image", src: frame1 },
  { type: "image", src: frame2 },
  { type: "image", src: frame3 },
  { type: "image", src: upcomingEventJuly },
  { type: "text", label: "POULTRY EXPO @Blr – 12,13,14 JUNE 2025" }, // static frame
];

const UpcomingEvent = () => {
  const INITIAL_SIZE = { width: 150, height: 100 };
  const [sizes, setSizes] = useState(imageFrames?.map(() => INITIAL_SIZE));
  const [activeIndex, setActiveIndex] = useState(null);
  const [zoomLast, setZoomLast] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);

  const calculateSizes = (clickedIndex) => {
    return imageFrames?.map((_, index) => {
      const distance = Math.abs(index - clickedIndex);
      if (distance === 0) return { width: 400, height: 250 };
      if (distance === 1) return { width: 200, height: 150 };
      return { width: 100, height: 80 };
    });
  };

  const handleClick = (index) => {
    setActiveIndex(index);
    setSizes(calculateSizes(index));
    if (index === 3) {
      setTimeout(() => setZoomLast(true), 500);
    } else {
      setZoomLast(false);
    }
  };

  useEffect(() => {
    const totalEntranceTime = imageFrames?.length * 200 + 500;
    const timeout = setTimeout(() => {
      handleClick(3);
      setHasMounted(true);
    }, totalEntranceTime);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "30px",
        padding: "40px 20px",
        flexWrap: "nowrap",
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        minHeight: "300px",
      }}
    >
      {imageFrames?.map((item, index) => (
        <motion.div
          key={index}
          onClick={() => handleClick(index)}
          animate={{
            width: sizes[index].width,
            height: sizes[index].height,
            opacity: 1,
            x: 0,
          }}
          initial={
            !hasMounted
              ? {
                  opacity: 0,
                  x: 100,
                  width: INITIAL_SIZE.width,
                  height: INITIAL_SIZE.height,
                }
              : false
          }
          transition={{
            opacity: { delay: index * 0.2, duration: 0.5 },
            x: { delay: index * 0.2, duration: 0.5 },
            width: { duration: 0.5 },
            height: { duration: 0.5 },
          }}
          style={{
            overflow: "hidden",
            position: "relative",
            boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            backgroundColor: "white",
            cursor: "pointer",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            minWidth: "100px",
            zIndex: activeIndex === index ? 10 : 1,
            transition: "z-index 0.3s ease",
          }}
        >
          {item?.type === "image" ? (
            <motion.img
              src={item.src}
              alt={`event ${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              animate={{
                scale: zoomLast && index === 3 ? 1.05 : 1,
              }}
              transition={{ scale: { duration: 0.5 } }}
            />
          ) : (
            <motion.div
              style={{
                width: "100%",
                height: "100%",
                fontSize: "1rem",
                fontWeight: "bold",
                color: "#ffffff",
                backgroundColor: "#1e293b",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px",
                borderRadius: "8px",
                wordBreak: "break-word",
                overflow: "hidden",
              }}
              animate={{
                scale: zoomLast && index === 4 ? 1.05 : 1,
              }}
              transition={{ scale: { duration: 0.5 } }}
            >
              {item.label}
            </motion.div>
          )}
        </motion.div>
      ))}
    </div>
  );
};

export default UpcomingEvent;
